import React, { useCallback, useState } from "react";
import WorkplaceRequiredModal from "../components/common/workplace-required/WorkplaceRequiredModal";
import { useCompanyWorkplaces } from "./useCompanyWorkplaces";

/**
 * Blocks an action when the company has no active workplaces and shows WorkplaceRequiredModal.
 * @param {'default' | 'documents' | 'timesheets' | 'attendance' | 'salaryComponents' | 'payrollStructures' | 'users'} [messageKey]
 */
export function useWorkplaceGate(messageKey = "default") {
  const { loading, hasWorkplaces } = useCompanyWorkplaces();
  const [modalOpen, setModalOpen] = useState(false);

  const showWorkplaceRequired = useCallback(() => {
    setModalOpen(true);
  }, []);

  const closeWorkplaceRequired = useCallback(() => {
    setModalOpen(false);
  }, []);

  /** @param {() => void} [action] */
  const withWorkplace = useCallback(
    (action) => {
      if (loading) return false;
      if (!hasWorkplaces) {
        setModalOpen(true);
        return false;
      }
      if (typeof action === "function") action();
      return true;
    },
    [hasWorkplaces, loading]
  );

  const workplaceRequiredModal = (
    <WorkplaceRequiredModal open={modalOpen} onClose={closeWorkplaceRequired} messageKey={messageKey} />
  );

  return {
    withWorkplace,
    showWorkplaceRequired,
    closeWorkplaceRequired,
    workplaceRequiredModal,
    hasWorkplaces,
    workplacesLoading: loading,
  };
}
